import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { Discount, DiscountUpdate, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

interface UpdateDiscountPayload extends DiscountUpdate {
  discountId: string;
  name: string;
}

export default function useUpdateDiscount(): UseMutationResult<
  AxiosResponse<Discount>,
  AxiosError<ErrorMessage>,
  UpdateDiscountPayload
> {
  const queryClient = useQueryClient();

  const updateDiscount = ({
    discountId,
    ...payload
  }: UpdateDiscountPayload): Promise<AxiosResponse<Discount>> => {
    return client.put(`discounts/${discountId}/`, payload);
  };

  return useMutation(updateDiscount, {
    onSuccess: () => {
      queryClient.invalidateQueries('discounts');
    },
  });
}
